import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import SuiInput from "components/SuiInput";

const MontoInput = ({ value = "", onChange }) => {
  const [formattedValue, setFormattedValue] = useState("");

  const formatCurrency = (input) => {
    // Si el valor es un string con formato de moneda, extraer solo el número
    if (typeof input === "string" && input.includes("$")) {
      input = input.replace(/[^\d,-]/g, "");
    }

    // Convertir a número si es string
    if (typeof input === "string" && !isNaN(input)) {
      input = Number(input);
    }

    // Si es un número válido, formatearlo
    if (typeof input === "number" && !isNaN(input)) {
      const formatter = new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });

      const formatted = formatter.format(input).replace(/\s/g, "");
      return {
        formatted,
        value: input,
      };
    }

    return {
      formatted: "$ 0",
      value: 0,
    };
  };

  useEffect(() => {
    if (value) {
      const { formatted } = formatCurrency(value);
      setFormattedValue(formatted);
    } else {
      setFormattedValue("");
    }
  }, [value]);

  const handleChange = (event) => {
    const { formatted, value: numericValue } = formatCurrency(event.target.value);
    setFormattedValue(formatted);
    onChange(numericValue); // Enviar el valor numérico al padre
  };

  return (
    <SuiInput
      value={formattedValue}
      onChange={handleChange}
      placeholder="$0"
      size="small"
      inputProps={{
        style: { textAlign: "right", paddingRight: "8px" },
      }}
    />
  );
};

MontoInput.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
};

export default MontoInput;
